import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";

export const dummyContactTeaser = {
    name: "Thomas Mischer",
    role: "role in the company",
    email: "M: thomas.mischer@trumpf.com",
    phone: "T: +49 152 4427217",
};

export const dummyContactTeaserExtended = {
    name: "机床事业部",
    email: [
        "M: tcn.spc.fd03@trumpf.com (MT_East) (机床部华东区客户商务支持邮箱)",
        "M: tcn.spc.fd04@trumpf.com (MT_South) (机床部华南区客户商务支持邮箱)",
        "M: tcn.spc.fd05@trumpf.com (MT_Ext.East&South) (机床部非华东华南区客户商务支持邮箱)",
    ],
    phone: ["T: 400-828-5030 (MT Service Hotline) (机床部全国服务热线"],
    hoursHeadline: "服务时间:",
    hoursContent: "周一 ~ 周五:上午8:30 ~下午5:30",
};

export const dummyContactTeaserUnit = {
    unitHeadline: "Responsible sales unit",
    phone: "T: +49 152 4427217",
    fax: "F: 813156 486 5616",
    email: "M: email@trumpf.com",
    hoursHeadline: "Business hours",
    hours: "Mo-Fr: 09:00 - 18:00",
};

export const dummyContacts = [
    {
        ...dummyContactTeaser,
    },
    {
        ...dummyContactTeaser,
        name: "John Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Jane Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Joey Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Monica Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Rachel Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Ross Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Chandler Doe",
    },
    {
        ...dummyContactTeaser,
        name: "Phoebey Doe",
    },
    {
        ...dummyContactTeaser,
    },
];

const renderContactTeaserImage = () => {
    return html` <!-- IMG BLOCK - Replace this block with a standard <picture> block with lazyloading -->
        ${renderStandardPictureElement({
            width: 150,
            height: 200,
        })}
        <!-- IMG BLOCK end -->`;
};

const renderMail = (item) => {
    return html`
        <a href="#" class="ux-text-link ux-text-link--green">${item}</a>
    `;
};

const renderPhone = (item) => {
    return html`
        <a href="#" class="ux-text-link ux-text-link--green">${item}</a>
    `;
};

export const TeaserContactTemplate = (args = dummyContactTeaser) => {
    return html`
        <div class="ux-iws-teaser-contact">
            <div class="ux-iws-teaser-contact__inner">
                <div class="ux-iws-teaser-contact__information">
                    <div class="ux-iws-teaser-contact__image-wrapper">
                        ${renderContactTeaserImage()}
                    </div>
                    <div class="ux-iws-teaser-contact__name-title">
                        <p class="ux-text-normal">${args.name}</p>
                        <div class="ux-text-tiny ux-u-text-uppercase">
                            <strong>${args.role}</strong>
                        </div>
                    </div>
                    <div class="ux-iws-teaser-contact__contacts">
                        <a href="#" class="ux-text-link ux-text-link--green"
                            >${args.email}</a
                        >
                        <a href="#" class="ux-text-link ux-text-link--green"
                            >${args.phone}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const TeaserContactExtendedTemplate = (
    args = dummyContactTeaserExtended
) => {
    return html`
        <div class="ux-iws-teaser-contact ux-iws-teaser-contact--extended">
            <div class="ux-iws-teaser-contact__inner">
                <div class="ux-iws-teaser-contact__information">
                    <div class="ux-iws-teaser-contact__name-title">
                        <div
                            class="ux-iws-teaser-contact__title ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                        >
                            ${args.name}
                        </div>
                    </div>
                    <div class="ux-iws-teaser-contact__contacts">
                        <div class="ux-iws-teaser-contact__mail">
                            ${args.email.map((item) => renderMail(item))}
                        </div>
                        <div class="ux-iws-teaser-contact__phone">
                            ${args.phone.map((item) => renderPhone(item))}
                        </div>
                    </div>
                    <div class="ux-iws-teaser-contact__business-hours">
                        <div
                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                        >
                            ${args.hoursHeadline}
                        </div>
                        <div class="ux-text-normal">
                            ${args.hoursContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const TeaserContactUnitTemplate = (args = dummyContactTeaserUnit) => {
    return html`
        <div class="ux-iws-teaser-contact ux-iws-teaser-contact--unit">
            <div class="ux-iws-teaser-contact__inner">
                <div class="ux-iws-teaser-contact__information">
                    <div class="ux-iws-teaser-contact__image-wrapper">
                        <ux-icon name="avatar"></ux-icon>
                    </div>
                    <div class="ux-iws-teaser-contact__unit-wrapper">
                        <div
                            class="ux-iws-teaser-contact__unit-headline ux-text-tiny ux-u-text-uppercase"
                        >
                            <strong>${args.unitHeadline}</strong>
                        </div>
                        <div class="ux-iws-teaser-contact__unit">
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.phone}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.fax}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.email}</a
                            >
                        </div>
                        <div class="ux-iws-teaser-contact__unit-mobile">
                            <div class="ux-text-tiny ux-u-text-uppercase">
                                <strong>${args.hoursHeadline}</strong>
                            </div>
                            <p class="ux-text-normal">${args.hours}</p>
                        </div>
                    </div>
                    <div class="ux-iws-teaser-contact__hours-wrapper">
                        <div class="ux-iws-teaser-contact__hours">
                            <div
                                class="ux-iws-teaser-contact__hours-headline ux-text-tiny ux-u-text-uppercase"
                            >
                                <strong>${args.hoursHeadline}</strong>
                            </div>
                            <p class="ux-text-normal">${args.hours}</p>
                        </div>
                        <div class="ux-iws-teaser-contact__hours-mobile">
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.phone}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.fax}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${args.email}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const TeaserContactListTemplate = () => html`
    <div class="ux-iws-teaser-contact-grid">
        ${dummyContacts.map((tile) => TeaserContactTemplate(tile))}
    </div>
`;
